import React, { useEffect, useState } from 'react';
import { api, dateStr } from '../lib/api';

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/audit?limit=300').then((r) => setLogs(r.data)); }, []);
  return (
    <div className="p-4 h-full overflow-y-auto">
      <h2 className="text-xl font-black mb-3">Auditoria</h2>
      <div className="space-y-1">
        {logs.map((l) => (
          <div key={l.id} className="bg-white rounded-lg border border-slate-100 p-2 text-xs">
            <div className="flex justify-between">
              <span className="font-bold">{l.action} · {l.entity}</span>
              <span className="text-slate-500">{dateStr(l.timestamp)}</span>
            </div>
            <div className="text-slate-600">{l.username} {l.entity_id ? `· ${l.entity_id.slice(0,8)}` : ''}</div>
            {l.details && Object.keys(l.details).length > 0 && (
              <div className="text-slate-500 mt-0.5">{JSON.stringify(l.details)}</div>
            )}
          </div>
        ))}
        {logs.length === 0 && <div className="text-slate-500 text-sm">Sem eventos</div>}
      </div>
    </div>
  );
}
